// @flow

import { PureComponent } from 'react';
import type { Node } from 'react';
import { connect } from 'react-redux';
import {
  selectGeoJSONURL,

  updateTileJSON,
} from './modules/map';

type Props = {
  children: Node,
  url: string,
  updateTileJSON: () => null,
};

class LoadTileJSON extends PureComponent<Props> {
  componentWillMount() {
    this.props.updateTileJSON();
  }

  componentWillReceiveProps({ url }: Props) {
    if (url !== this.props.url) {
      this.props.updateTileJSON();
    }
  }

  render = () => this.props.children;
}

const mapStateToProps = state => ({
  url: selectGeoJSONURL(state),
});

const mapDispatchToProps = {
  updateTileJSON,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoadTileJSON);



// WEBPACK FOOTER //
// ./src/load-tile-json.js